module.exports = __webpack_public_path__ + "static/img/classificacao-sentimento-grafico.abbeb42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/classificacao-sentimento-grafico.png
// module id = AHQs
// module chunks = 1